import styled, { css, keyframes } from 'styled-components';
import { FaSearch } from 'react-icons/fa';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const SearchIcon = styled(FaSearch)`
  ${({ $spinning }) =>
    $spinning &&
    css`
      animation: ${spin} 0.7s linear infinite;
    `}
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  padding: 0;
  background-color: ${({ theme }) => theme.colors.background};
  overflow: hidden;
`;

export const RelatorioPeriodoProdutos = styled.div`
  display: flex;
  padding: 0 16px;
`;

export const PageHeader = styled.header`
  display: flex;
  align-items: flex-end;   // era 'center'
  justify-content: space-between;
  gap: 16px;
  padding: 14px 24px;
  background-color: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  flex-shrink: 0;
`;

export const PageTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  white-space: nowrap;
`;

export const SearchWrapper = styled.div`
  flex: 1;
  max-width: 400px;
`;

export const DashboardRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 12px 24px;
  flex-shrink: 0;
  overflow-x: auto;
`;

export const KpiCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  min-width: 130px;
  flex: 1;
`;

export const KpiLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const KpiValue = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ${({ $color, theme }) => $color || theme.colors.text};
`;
export const ContentRow = styled.div`
  display: flex;
  gap: 16px;
  flex: 1;
  padding: 0 24px;
  overflow: hidden;
`;

export const TableColumn = styled.div`
  flex: 1.6;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const ChartsColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
`;

export const ChartCard = styled.div`
  padding: 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};

  svg > g > g:last-child {
    pointer-events: none;
  }
`;
export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 4px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const LegendDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
`;
export const ChartTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;